import { createContext } from 'react';

export const ApptRequestIvContext = createContext(null!);
